import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getSettingHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/setting/_layout/user/")({
    component: UserSettingsPage,
    staticData: {
        permissions: [PermissionEnum.SettingUser],
        showInSideMenu: false,
        label: "pages.setting.user.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.setting.user.title"),
        };
    },
});

function UserSettingsPage() {
    return (
        <TenantPage headerNavigationItems={getSettingHeaderItems} isEdit={true}>
            <></>
        </TenantPage>
    );
}
